import Icon from './Icon.tsx';
import url from '@assets/images/check-unselected.svg';

const CheckUnselectedIcon = () => {
  return <Icon icon={url} />;
};

export default CheckUnselectedIcon;
